module.exports = __webpack_public_path__ + "static/media/maintenance.3a5a1d11.png";